export default {
  dialogPurchase: {
    title: 'Achat Coupon'
  },
  buyed: 'Votre compon a bien été acheté !'
}
